import { createFormAction } from 'redux-form-saga'

const SELECT_REQUEST = 'materials/select/request'
const SELECT_SUCCESS = 'materials/select/success'
const SELECT_FAILURE = 'materials/select/failure'

const INSERT = createFormAction('MATERIALS_INSERT')

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE, INSERT }
